import * as React from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends React.Component {
  componentDidUpdate() {
    // PUSH での画面遷移以外は中断
    if (this.props.history.action !== 'PUSH') return;

    window.scrollTo(0, 0);
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/common/ScrollToTop/index.js